import { render } from "./KartListesi.vue?vue&type=template&id=6b8dbf02"
import script from "./KartListesi.vue?vue&type=script&lang=js"
export * from "./KartListesi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__